import { render, staticRenderFns } from "./BrandAuthorizationCertificate.vue?vue&type=template&id=4ba81360&scoped=true"
import script from "./BrandAuthorizationCertificate.vue?vue&type=script&lang=js"
export * from "./BrandAuthorizationCertificate.vue?vue&type=script&lang=js"
import style0 from "./BrandAuthorizationCertificate.vue?vue&type=style&index=0&id=4ba81360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba81360",
  null
  
)

export default component.exports